import React from 'react';
import PropTypes from 'prop-types';

class HyojunhoshuInput extends React.Component {
  render() {
    const {
      userPayrolls,
      optionAttributes,
      onSelectFocus,
      onSelectChange,
      settingsBand
    } = this.props;

    // #2129: 設定セクションの縦書き帯 + 項目名列構成。settingsBand 時は th2 単一列。
    const labelTh = settingsBand
      ? <th className="item th2 no-min-width hyojunhoshu"><span>標準報酬月額(千円)</span></th>
      : <th className="th1 item w14 no-min-width hyojunhoshu" colSpan="2"><span>標準報酬月額(千円)</span></th>;

    return (
      <tr>
        {labelTh}
        {userPayrolls.map((userPayroll, index) => {
          if (userPayroll.puShakaiHoken !== 'social_insurance_auto' && userPayroll.puNenkinHoken !== 'welfare_pension_auto') {
            return (
              <td className="salary w9" key={index}>
                <select className="inputNumber puHyojunHoshu payment-updater" disabled name={`user[${userPayroll.uID}][puHyojunHoshu]`}>
                  <option value="0">-</option>
                </select>
              </td>
            );
          } else {
            return (
              <td className="salary w9" key={index}>
                <select className="inputNumber puHyojunHoshu payment-updater" name={`user[${userPayroll.uID}][puHyojunHoshu]`}
                  onChange={(e) => onSelectChange(e, index, 'puHyojunHoshu')}
                  onFocus={(e) => onSelectFocus(e, userPayroll.uID, 'puHyojunHoshu' )}
                  value={userPayroll.puHyojunHoshu}
                >
                  {optionAttributes.map((obj, idx) => <option key={idx} value={obj.value}>{obj.text}</option>)}
                </select>
              </td>
            );
          }
        })}
      </tr>
    );
  }
}

HyojunhoshuInput.propTypes = {
  userPayrolls: PropTypes.array.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  onSelectFocus: PropTypes.func.isRequired,
  optionAttributes: PropTypes.array.isRequired,
  settingsBand: PropTypes.bool,
};

export default HyojunhoshuInput;
